import { useState, useEffect } from 'react';
import { stsuiWebSocketService } from '../services/stsuiWebsocket';
export const useStsuiSubscription = (room) => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(!!room);
    useEffect(() => {
        if (!room) {
            setData(null);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        const callback = (newData) => {
            setData(newData);
            setIsLoading(false);
        };
        stsuiWebSocketService.subscribe(room, callback);
        return () => {
            stsuiWebSocketService.unsubscribe(room, callback);
        };
    }, [room]);
    useEffect(() => {
        const unsubscribe = stsuiWebSocketService.onConnectionStatusChange(() => {
            const connectionStatus = stsuiWebSocketService.getConnectionStatus();
            if (connectionStatus === 'connecting' && data) {
                setIsLoading(true);
            }
            else if (connectionStatus === 'reconnecting' && data) {
                setIsLoading(true);
            }
            else if (connectionStatus === 'connected' && data) {
                // Don't immediately hide loading - let fresh data arrival hide it
            }
            else if (connectionStatus === 'disconnected' && data) {
                setIsLoading(false); // Keep showing cached data when disconnected
            }
        });
        return unsubscribe;
    }, [data]);
    return {
        data,
        isLoading,
    };
};
